import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-play',
  templateUrl: './icon-play.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconPlayComponent {}
